import React, { useRef, useState, useEffect } from 'react';
import { motion, useViewportScroll, useTransform, useSpring } from "framer-motion";
import InView from 'react-intersection-observer';
import HeaderAnim from '../utils/animations/textRevealAnimation';

export default function PageFeatureBanner(props) {
  const { classes, header, subHeader, content, link, image, alt, title, imageIsInsideRow } = props.data;
  const yOffset = 200; // number > 0
  const easing = [0.42, 0, 0.58, 1];
  // easing = "easeInOut", // [number, number, number, number] | "linear" | "easeIn" |
  //"easeOut" | "easeInOut" | "circIn" | "circOut" | "circInOut" | "backIn" | "backOut" |
  //"backInOut" | "anticipate" | EasingFunction;
  const triggerPoint = 0.8; // value between 0 and 1 (top and bottom of the window), point to start animation
  const fadeOut = true; // true | false fade an element out on end of the animation

  const { scrollY } = useViewportScroll();
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);
  const [elementTop, setElementTop] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);

  const setValues = () => {
    setElementTop(ref.current.offsetTop);
    setClientHeight(window.innerHeight);
  };

  useEffect(() => {
    if (!ref.current) return;

    setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);

    return () => {
      document.removeEventListener("load", setValues);
      window.removeEventListener("resize", setValues);
    };
  }, [isVisible]);

  // const transformInitialValue =
  //   elementTop - window.innerHeight <= 0 ? 0 : elementTop - window.innerHeight;
  const transformInitialValue = elementTop - clientHeight * triggerPoint;

  const transformFinalValue = elementTop;

  const yRange = [transformInitialValue, transformFinalValue];

  const y = useSpring(useTransform(scrollY, [elementTop - clientHeight * 1.1, elementTop - clientHeight * 0.5], [yOffset, 0], easing), { damping: 50, stiffness: 500 });

  const textTriggers = [0.7, 0.6, 0.5, 0.4, 0.3, 0.2];

  const setTransformValue = (t) => {
    return elementTop - clientHeight * t;
  };

  const y1 = useTransform(scrollY, [setTransformValue(textTriggers[0]), setTransformValue(textTriggers[2])], [-50, 0], easing);
  const y2 = useTransform(scrollY, [setTransformValue(textTriggers[1]), setTransformValue(textTriggers[3])], [-50, 0], easing);
  const y3 = useTransform(scrollY, [setTransformValue(textTriggers[2]), setTransformValue(textTriggers[4])], [-50, 0], easing);
  const y4 = useTransform(scrollY, [setTransformValue(textTriggers[3]), setTransformValue(textTriggers[5])], [-50, 0], easing);
  const y5 = useTransform(scrollY, [setTransformValue(textTriggers[4]), setTransformValue(textTriggers[6])], [-50, 0], easing);

  const y1Op = useTransform(scrollY, [setTransformValue(textTriggers[0]), setTransformValue(textTriggers[2])], [0, 1], easing);
  const y2Op = useTransform(scrollY, [setTransformValue(textTriggers[1]), setTransformValue(textTriggers[3])], [0, 1], easing);
  const y3Op = useTransform(scrollY, [setTransformValue(textTriggers[2]), setTransformValue(textTriggers[4])], [0, 1], easing);
  const y4Op = useTransform(scrollY, [setTransformValue(textTriggers[3]), setTransformValue(textTriggers[5])], [0, 1], easing);
  const y5Op = useTransform(scrollY, [setTransformValue(textTriggers[4]), setTransformValue(textTriggers[6])], [0, 1], easing);

  /*   if (isVisible) {
      ref.current.scrollTop({
        behavior: "smooth",
      });
    }
  
    const handleChange = () => {
  
    } */
  return (
    <div ref={ref}>
      <InView as='div' onChange={inView => setIsVisible(inView)} className={`page-product-banner-section-style-2 d-flex align-v-center section-gap ${classes}`} id={props.id ? props.id : ''} threshold={[0.3]} onLoad={setValues}>
        <div className="container">
          <div className="row d-flex flex-wrap align-v-center justify-space">
            <div className="col product-banner-detail-style-2 d-flex align-v-center">
              <div className="product-banner-detail-inner">
                {header && <p className="theme-color-title">{isVisible && <HeaderAnim header={header} />}</p>}
                {subHeader && <motion.h2 style={{ x: y1, opacity: y1Op }} className="h3">{subHeader}</motion.h2>}
                {content && <motion.p style={{ x: y2, opacity: y2Op }}>{content}</motion.p>}
                <motion.span style={{ x: y3, opacity: y3Op }}>
                  {link}
                </motion.span>
              </div>
            </div>
            {
              imageIsInsideRow &&
              <motion.div style={{ x: y }} className="col product-banner-image-style-2">
                <img src={image} alt={alt} title={title} />
              </motion.div>
            }
          </div>

          {
            !imageIsInsideRow &&
            <motion.div style={{ x: y }} className="product-banner-image-style-2">
              <img src={image} alt="page-banner-web-development" />
            </motion.div>
          }
        </div>
      </InView>
    </div>
  );
}
